import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { InlineImageWrapperContentComponent } from '@ppg/core/models';
import { RichTextComponent } from '@ppg/shared/rich-text';

import { InlineImageComponent } from '../inline-image/inline-image.component';

@Component({
  selector: 'ppg-inline-image-wrapper',
  standalone: true,
  templateUrl: './inline-image-wrapper.component.html',
  styleUrl: './inline-image-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InlineImageComponent, RichTextComponent],
})
export class InlineImageWrapperComponent {
  readonly content = input.required<InlineImageWrapperContentComponent>();

  readonly text = computed(() => this.content().texts.reduce((acc, t) => acc + t.content, ''));
}
